import request from "@/utils/request";

// 查询双倍佣金内容
export function getDoubleCommissionDetail() {
  return request({
    url: '/product/commission/h5/queryDoubleCommission',
    method: 'get'
  })
}
// 查询双倍佣金列表
export function getDoubleCommissionList() {
  return request({
    url: '/product/special-double/h5/list',
    method: 'get',
  })
}